import K_AccordionPanel from "../templates/K_AccordionPanel";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface AccordionPanelOptions extends ComponentOptions {
    components?: Component[];
}

export class AccordionPanel extends TemplateComponent {

    options: AccordionPanelOptions;
    content: {
        components: Component[];
    };

    constructor(options: AccordionPanelOptions) {
        super(K_AccordionPanel, options);

        this.content = {
            components: options.components || []
        };
    }

}
